import { toString30pk9tzaqopn as toString } from '../../../../../../kotlin-kotlin-stdlib/kotlin/Library.mjs';
import {
  equals2au1ep9vhcato as equals,
  getStringHashCode26igk1bx568vk as getStringHashCode,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { Data_getInstance1oeb8obtiom5s as Data_getInstance } from './adapter/CreateSecretMutation_ResponseAdapter.mjs';
import {
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
  initMetadataForCompanion1wyw17z38v6ac as initMetadataForCompanion,
} from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import { CreateSecretMutation_VariablesAdapter_instance1eiqalsklrcs8 as CreateSecretMutation_VariablesAdapter_instance } from './adapter/CreateSecretMutation_VariablesAdapter.mjs';
import { obj2vqjd1bjrpmyg as obj } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Adapters.mjs';
import { Mutationkenyz0l5btz as Mutation } from '../../../../../../apollo-kotlin-apollo-api/com/apollographql/apollo/api/Mutation.mjs';
//region block: imports
var imul = Math.imul;
//endregion
//region block: pre-declaration
//endregion
var DataClass;
function Data() {
  if (DataClass === VOID) {
    class $ {
      constructor(createSecret) {
        this.m6d_1 = createSecret;
      }
      toString() {
        return 'Data(createSecret=' + toString(this.m6d_1) + ')';
      }
      hashCode() {
        return this.m6d_1 == null ? 0 : this.m6d_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof Data()))
          return false;
        if (!equals(this.m6d_1, other.m6d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'Data', VOID, VOID, VOID, VOID, VOID, {1: Data_getInstance});
    DataClass = $;
  }
  return DataClass;
}
var CreateSecretClass;
function CreateSecret() {
  if (CreateSecretClass === VOID) {
    class $ {
      constructor(secretId, description, createdTimestamp, lastUsedTimestamp, secretToken) {
        this.n6d_1 = secretId;
        this.o6d_1 = description;
        this.p6d_1 = createdTimestamp;
        this.q6d_1 = lastUsedTimestamp;
        this.r6d_1 = secretToken;
      }
      toString() {
        return 'CreateSecret(secretId=' + this.n6d_1.toString() + ', description=' + this.o6d_1 + ', createdTimestamp=' + this.p6d_1.toString() + ', lastUsedTimestamp=' + toString(this.q6d_1) + ', secretToken=' + this.r6d_1 + ')';
      }
      hashCode() {
        var result = this.n6d_1.hashCode();
        result = imul(result, 31) + getStringHashCode(this.o6d_1) | 0;
        result = imul(result, 31) + this.p6d_1.hashCode() | 0;
        result = imul(result, 31) + (this.q6d_1 == null ? 0 : this.q6d_1.hashCode()) | 0;
        result = imul(result, 31) + getStringHashCode(this.r6d_1) | 0;
        return result;
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecret()))
          return false;
        if (!this.n6d_1.equals(other.n6d_1))
          return false;
        if (!(this.o6d_1 === other.o6d_1))
          return false;
        if (!this.p6d_1.equals(other.p6d_1))
          return false;
        if (!equals(this.q6d_1, other.q6d_1))
          return false;
        if (!(this.r6d_1 === other.r6d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecret');
    CreateSecretClass = $;
  }
  return CreateSecretClass;
}
var CompanionClass;
function Companion() {
  if (CompanionClass === VOID) {
    class $ {
      constructor() {
        this.s6d_1 = 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
        this.t6d_1 = 'createSecret';
      }
      u6d() {
        return 'mutation createSecret($input: CreateSecretInput!) { createSecret(input: $input) { secretId description createdTimestamp lastUsedTimestamp secretToken } }';
      }
    }
    initMetadataForCompanion($);
    CompanionClass = $;
  }
  return CompanionClass;
}
var Companion_instance;
function Companion_getInstance() {
  return Companion_instance;
}
var CreateSecretMutationClass;
function CreateSecretMutation() {
  if (CreateSecretMutationClass === VOID) {
    class $ {
      constructor(input) {
        this.v6d_1 = input;
      }
      w6d() {
        return 'ebc30c0645cf276dd3d78eb42594ec195bdc601bd1d9fe71ba29e8b002fabc48';
      }
      operationId() {
        return this.w6d();
      }
      v47() {
        return Companion_instance.u6d();
      }
      x6d() {
        return 'createSecret';
      }
      operationName() {
        return this.x6d();
      }
      p46(writer, customScalarAdapters, withDefaultValues) {
        CreateSecretMutation_VariablesAdapter_instance.y6d(writer, this, customScalarAdapters, withDefaultValues);
      }
      o46() {
        return obj(Data_getInstance());
      }
      toString() {
        return 'CreateSecretMutation(input=' + this.v6d_1.toString() + ')';
      }
      hashCode() {
        return this.v6d_1.hashCode();
      }
      equals(other) {
        if (this === other)
          return true;
        if (!(other instanceof CreateSecretMutation()))
          return false;
        if (!this.v6d_1.equals(other.v6d_1))
          return false;
        return true;
      }
    }
    initMetadataForClass($, 'CreateSecretMutation', VOID, VOID, [Mutation()]);
    CreateSecretMutationClass = $;
  }
  return CreateSecretMutationClass;
}
//region block: init
Companion_instance = new (Companion())();
//endregion
//region block: exports
export {
  CreateSecret as CreateSecretg99oj6r6hso0,
  Data as Data1ybn66w6c74sz,
  CreateSecretMutation as CreateSecretMutation3m5frrt825225,
};
//endregion

//# sourceMappingURL=CreateSecretMutation.mjs.map
